/**
 * Cliente único de Subasta V2 (P-18) — Panel.
 */
import { AxiosInstance } from '../../../utils/constants';

const newIdempotencyKey = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `idemp-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

const parseError = (error, fallbackCode = 'UNKNOWN') => {
  const data = error?.response?.data || {};
  return {
    status: false,
    code: data.code || fallbackCode,
    msg: data.msg || error?.message || 'Error de red',
    precio_vigente: data.precio_vigente ?? null,
    version: data.version ?? null,
    http: error?.response?.status || 0,
  };
};

export const auctionApi = {
  async getSnapshot(cod) {
    const { data } = await AxiosInstance.get(`subastas/v2/${cod}`);
    return data;
  },

  async ofertar({ cod_subasta, valor_ofertado, version, idempotencyKey }) {
    try {
      const { data } = await AxiosInstance.post(
        'subastas/v2/ofertar',
        { cod_subasta, valor_ofertado, version },
        { headers: { 'Idempotency-Key': idempotencyKey || newIdempotencyKey() } }
      );
      return data;
    } catch (error) {
      throw parseError(error, 'BID_FAILED');
    }
  },

  async aceptarOferta({ cod_subasta, cod_bid, version, idempotencyKey }) {
    try {
      const { data } = await AxiosInstance.post(
        'subastas/v2/aceptar-oferta',
        { cod_subasta, cod_bid, version },
        { headers: { 'Idempotency-Key': idempotencyKey || newIdempotencyKey() } }
      );
      return data;
    } catch (error) {
      throw parseError(error, 'ACCEPT_FAILED');
    }
  },
};

export { newIdempotencyKey, parseError };
